import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/code/codeForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const CodeFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

CodeFormPage.propTypes = {};

export default CodeFormPage;
